module.exports = __webpack_public_path__ + "images/home-dingtalk-work/tower_dingtalk@2x-41c60ec4aa0b5f5f796c790b1ddedaf1.png";